/*!
 * avgrund 0.1
 * http://lab.hakim.se/avgrund
 * MIT licensed
 *
 * Copyright (C) 2012 Hakim El Hattab, http://hakim.se
 */
var Avgrund = (function () {

	var container = document.documentElement,
		popup = document.querySelector('.avgrund-popup-animate'),
		cover = document.querySelector('.avgrund-cover'),
		currentState = null,
		modalEl;

	container.classList.add('avgrund-ready');

	// Deactivate on ESC
	function onDocumentKeyUp(event) {
		if (event.keyCode === 27) {
			deactivate();
		}
	}

	// Deactivate on click outside
	function onDocumentClick(event) {
		if (event.target === cover) {
			deactivate();
		}
	}

	function activate(state) {
		document.addEventListener('keyup', onDocumentKeyUp, false);
		document.addEventListener('click', onDocumentClick, false);
		document.addEventListener('touchstart', onDocumentClick, false);

		popup.classList.remove(currentState);
		popup.classList.add('no-transition');
		if (state) popup.classList.add(state);

		setTimeout(function () {
			popup.classList.remove('no-transition');
			container.classList.add('avgrund-active');
		}, 0);

		currentState = state;
	}

	function deactivate() {
		document.removeEventListener('keyup', onDocumentKeyUp, false);
		document.removeEventListener('click', onDocumentClick, false);
		document.removeEventListener('touchstart', onDocumentClick, false);

		container.classList.remove('avgrund-active');
		popup.classList.remove('avgrund-popup-animate');

		setTimeout(function () {
			popup.classList.add('avgrund-popup-hidden')
		}, 400);
	}


	function hide() {
		deactivate();
	}


	function show(selector) {
		if (typeof selector === 'string') {
			popup = document.querySelector(selector);
		} else {
			popup = selector;
		}
		if (!popup.nodeName) return false;

		popup.classList.remove('avgrund-popup-hidden');
		popup.classList.add('avgrund-popup');
		popup.classList.add('avgrund-popup-animate');

		activate();
		return this;
	}

	function createModal(id) {
		var el = document.createElement('div');
		el.className = 'avgrund-popup';
		el.id = id;

		document.body.appendChild(el);
		return el;
	}


	function showMessage(obj) {

		var msg = {},
			html = '',
			defaultAction = '<button class="btn-ok" onclick="Avgrund.hide()">Ok</button>';

		if (typeof obj === 'string') {
			msg.actions = defaultAction;
			msg.body = obj;
		} else {
			msg = obj;
		}

		if (msg.title) html += '<h2 class="avgrund-title">' + msg.title + '</h2>';
		if (msg.body) html += '<div class="avgrund-body">' + msg.body + '</div>';

		html += '<div class="avgrund-actions">' + (msg.actions || defaultAction) + '</div>';

		modalEl.innerHTML = html;
		show(modalEl);
	}

	function init() {
		var id = 'avgrund-modal';

		modalEl = document.getElementById(id) || createModal(id);

		if (!cover) {
			cover = document.createElement('div');
			cover.className = 'avgrund-cover';
			document.body.appendChild(cover);
		}
	}

	init();

	return {
		activate: activate,
		deactivate: deactivate,
		show: show,
		showMessage: showMessage,
		hide: hide
	}
})();

export default Avgrund;
